import request from '../utils/request';

// 分页查询资讯文章类型列表
export const listArticleTypes = (page = 1, size = 10, queryDTO = {}) => {
  return request({
    url: '/article-type/list',
    method: 'post',
    params: { page, size },
    data: queryDTO
  });
};

// 获取所有启用的文章类型列表
export const listEnabledArticleTypes = () => {
  return request({
    url: '/article-type/list/enabled',
    method: 'get'
  });
};

// 根据ID获取文章类型详情
export const getArticleTypeById = (id) => {
  return request({
    url: `/article-type/${id}`,
    method: 'get'
  });
};

// 创建文章类型
export const createArticleType = (data) => {
  return request({
    url: '/article-type',
    method: 'post',
    data
  });
};

// 更新文章类型
export const updateArticleType = (id, data) => {
  return request({
    url: `/article-type/${id}`,
    method: 'put',
    data
  });
};

// 删除文章类型
export const deleteArticleType = (id) => {
  return request({
    url: `/article-type/${id}`,
    method: 'delete'
  });
};

